import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    Layout,
    Typography,
    Form,
    Input,
    Select,
    Button,
    Table,
    Card,
    Row,
    Col,
    Breadcrumb,
    Tag,
    Spin,
    Space,
    Modal,
    Descriptions,
} from 'antd';
import axios from 'axios';
import { APPBACKGROUND_COLOR, MAINAPIURL } from '../appsettings';
import Headerdiv from '../layout/header';
import Footerdiv from '../layout/footer';
import { AlertError, AlertSuccess } from '../usableclasses';

const { Content } = Layout;
const { Option } = Select;

const UserRequests = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const UPDATEDBY = localStorage.getItem("USERID");


    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");

    const [isLoading, setIsLoading] = useState(false);
    const [userRequests, setUserRequests] = useState([]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    const fetchUserRequests = async (filters = {}) => {
        setIsLoading(true);
        try {
            const headers = {
                SystemAccessToken: TOKEN,
            }
            const response = await axios.post(
                `${ApiURL}/erp/mlmuser/requestlist`,
                {
                    requestType: filters.requestType || '',
                    requestStatus: 'PENDING',
                    userId: filters.userId ? parseInt(filters.userId) : 0
                },
                { headers }
            );
            setUserRequests(response.data || []);
        } catch (error) {
            console.error(error);
            AlertError("Error fetching user requests");
        }
        setIsLoading(false);
    };

    const handleFilter = () => {
        const values = form.getFieldsValue();
        fetchUserRequests(values);
    };

    const handleClear = () => {
        form.resetFields();
        fetchUserRequests();
    };

    useEffect(() => {
        fetchUserRequests();
    }, []);

    const showVerifyModal = async (requestId) => {
        setModalLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/erp/mlmuser/userrequestprofiledata/${requestId}`, { headers });
            setSelectedRequest(response.data);
            setIsModalVisible(true);
        } catch (err) {
            AlertError("Failed to fetch request details");
        } finally {
            setModalLoading(false);
        }
    };

    const columns = [
                {
            title: 'Consultant ID',
            dataIndex: 'requestUserId',
            key: 'requestUserId',
            render: (val) => <Link to={`/mlm/userview/${val}`}>{val}</Link>
        },
        {
            title: 'Consultant Name',
            dataIndex: 'requestUser',
            key: 'requestUser',
        },
        {
            title: 'Request Type',
            dataIndex: 'requestType',
            key: 'requestType',
        },
        {
            title: 'Status',
            dataIndex: 'requestStatus',
            key: 'requestStatus',
            render: (status) => <Tag color={status === 'PENDING' ? 'orange' : 'green'}>{status}</Tag>,
        },
        {
            title: 'Submitted On',
            dataIndex: 'reqSubmitDT',
            key: 'reqSubmitDT',
            render: (date) => date ? new Date(date).toLocaleString() : '-',
        },
        {
            title: 'Checked By',
            dataIndex: 'reqCheckedBy',
            key: 'reqCheckedBy',
            render: (val) => val || '-',
        },
        {
            title: 'Checked On',
            dataIndex: 'reqCheckedDT',
            key: 'reqCheckedDT',
            render: (date) => date ? new Date(date).toLocaleString() : '-',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Button 
                type='primary' 
                variant='solid' 
                size='small' 
                color='yellow'
                onClick={() => showVerifyModal(record.requestId)}>
                    Review
                </Button>
            )
        }
    ];
    const handleApproval = async (approvalStatus) => {
        if (!selectedRequest) return;
        try {
            setIsLoading(true);
            setModalLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const res = await axios.post(`${ApiURL}/erp/mlmuser/userrequestapproval`, {
                requestId: selectedRequest.approvalReqId,
                consultantId: selectedRequest.consultantId,
                approvalArea: selectedRequest.reqType === 'Bank' ? 'BANK' : 'PROFILE',
                approvalStatus,
                approvedBy: UPDATEDBY
            }, { headers });
            if (res.data === true) {
                setIsModalVisible(false);
                fetchUserRequests();
                AlertSuccess('Request status updated successfully');
            } else {
                AlertError('Failed to update request status');
            }
        } catch (err) {
            AlertError('Failed to update request status');
        } finally {
            setModalLoading(false);
            setIsLoading(false);
        }
    };

    const handleFileDownload = async (file) => {
        try {
            const headers = {
                SystemAccessToken: TOKEN,
            }
            const response = await axios.post(`${ApiURL}/erp/mlmuser/downloadfile`, { fileName: file }, { responseType: 'blob', headers }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.log(error)
            AlertError('Error downloading file');
        }
    }

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px' }}>
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item><Link to={"/mlm/userlist"}>MLM User</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>User Requests</Breadcrumb.Item>
                </Breadcrumb>

                <Card title="Filter Requests" style={{ marginBottom: 16 }}>
                    <Form form={form} layout="vertical">
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={6} lg={4}>
                                <Form.Item label="Consultant ID" name="userId">
                                    <Input placeholder="Enter Consultant ID" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6} lg={4}>
                                <Form.Item label="Request Type" name="requestType">
                                    <Select placeholder="Select Request Type" allowClear>
                                        <Option value="BANK">Bank</Option>
                                        <Option value="PROFILE">Profile</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={24} md={12} lg={6}>
                                <Form.Item label=" ">
                                    <Space wrap>
                                        <Button type="primary" onClick={handleFilter}>
                                            Filter
                                        </Button>
                                        <Button onClick={handleClear}>
                                            Clear
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>

                <Card title="User Requests List">
                    <Table
                        columns={columns}
                        dataSource={userRequests}
                        loading={isLoading}
                        rowKey="requestId"
                        pagination={{ pageSize: 10 }}
                    />
                </Card>

                <Modal
                    open={isModalVisible}
                    title="Request Approval"
                    onCancel={() => setIsModalVisible(false)}
                    footer={[
                        <Button key="reject" danger onClick={() => handleApproval('REJECTED')}>
                            Reject
                        </Button>,
                        <Button key="accept" type="primary" onClick={() => handleApproval('APPROVED')}>
                            Approve
                        </Button>,
                    ]}
                    width={700}
                    confirmLoading={modalLoading}
                >
                    {selectedRequest ? (
                        <>
                            <Descriptions bordered column={2} size="small">
                                <Descriptions.Item label="Consultant ID">{selectedRequest.consultantId}</Descriptions.Item>
                                <Descriptions.Item label=" " />
                                <Descriptions.Item label="First Name">{selectedRequest.firstName}</Descriptions.Item>
                                <Descriptions.Item label="Second Name">{selectedRequest.secondName}</Descriptions.Item>
                            </Descriptions>

                            <br />

                            <Row align="middle" gutter={8}>
                                <Col>
                                    <Typography.Text strong>Request Type:</Typography.Text>
                                </Col>
                                <Col>
                                    <Tag color="purple">{selectedRequest.reqType}</Tag>
                                </Col>
                            </Row>

                            <Descriptions bordered column={1} size="small" layout="vertical">
                                {selectedRequest.reqType === "Profile" && (
                                    <>
                                        <Descriptions.Item label="NIC No">{selectedRequest.regDocNo}</Descriptions.Item>
                                        <Descriptions.Item label="DOWNLOAD">
                                            <div style={{ marginTop: 16 }}>
                                                <Button onClick={() => handleFileDownload(selectedRequest.regDocFile)} type="default" color='primary' variant='solid' href={selectedRequest.docUrl} target="_blank">
                                                    Download Document
                                                </Button>
                                            </div>
                                        </Descriptions.Item>
                                    </>)}
                                {selectedRequest.reqType === "Bank" && (
                                    <>
                                        <Descriptions.Item label="Bank Name">{selectedRequest.bankName}</Descriptions.Item>
                                        <Descriptions.Item label="Branch Name">{selectedRequest.bankBranchName}</Descriptions.Item>
                                        <Descriptions.Item label="Acc Name">{selectedRequest.bankAccName}</Descriptions.Item>
                                        <Descriptions.Item label="Acc No">{selectedRequest.bankAccNo}</Descriptions.Item>
                                        <Descriptions.Item label="DOWNLOAD">
                                            <div style={{ marginTop: 16 }}>
                                                <Button onClick={() => handleFileDownload(selectedRequest.bankDocFile)} type="default" color='primary' variant='solid' href={selectedRequest.docUrl} target="_blank">
                                                    Download Document
                                                </Button>
                                            </div>
                                        </Descriptions.Item>
                                    </>)
                                }
                            </Descriptions>

                        </>
                    ) : (
                        <Spin />
                    )}
                </Modal>
            </Content>
            <Footerdiv />
        </Layout>
    );
};

export default UserRequests;
